// eg-collections-config-sort.js
// Sort options + custom sort definitions (ES5-safe)

(function () {
  // Shared definitions (re-usable across collections)
  var DEFAULT_DEFS = {
    // Numeric tag like "Width_490mm"
    width_mm: { kind: "tag_number", prefix: "Width_", unit: "mm" },
    length_mm: { kind: "tag_number", prefix: "Length_", unit: "mm" },
    thickness_mm: { kind: "tag_number", prefix: "Thickness_", unit: "mm" },
    height_mm: { kind: "tag_number", prefix: "Height_", unit: "mm" },
    sleeve_cm: { kind: "tag_number", prefix: "Sleeve-Length__", unit: "cm" },
    total_keys: { kind: "tag_number", prefix: "Total Keys__", unit: "" },

    // Computed area from width*length (mm^2)
    area_mm2: { kind: "tag_area", width_prefix: "Width_", length_prefix: "Length_", unit: "mm" },

    // Rank tags like "Surface Texture__Smooth"
    texture_rank: {
      kind: "tag_rank",
      prefix: "Surface Texture__",
      order: ["Ultra Smooth", "Very Smooth", "Smooth", "Slightly Textured", "Slightly Grainy", "Grainy", "Textured", "Honey Comb", "Slightly Rough", "Rough"] // EDIT to your exact tag values
    },

    // Rank tags like "Firmness__Soft"
    firmness_rank: {
      kind: "tag_rank",
      prefix: "Firmness__",
      order: ["Extra Soft", "Soft", "Mid", "Hard"] // EDIT to your exact tag values
    }
  };

  // Default sort buttons shown on all collections (unless overridden)
  var DEFAULT_OPTIONS = [
    { key: "featured", label: "Most Popular" },
    { key: "newest", label: "Newest" },
    { key: "price_asc", label: "Price: Low - High" },
    { key: "price_desc", label: "Price: High - Low" },
    { key: "title_asc", label: "Alphabetical" }
   // { key: "title_desc", label: "Name: Z–A" }
  ];

  window.EG_COLLECTION_SORT_CONFIG = {
    defaults: {
      options: DEFAULT_OPTIONS,
      defs: DEFAULT_DEFS
    },

    collections: {
      "gaming-mousepads": {
        // Override the visible option list for mousepads
        options: [
          { key: "area_asc", label: "Size: Small - Large" },
         // { key: "area_desc", label: "Size: Large to Small" },

         // { key: "length_asc", label: "L: Small to Large" },
         // { key: "length_desc", label: "L: Large to Small" },

        //  { key: "width_asc", label: "W: Small to Large" },
        //  { key: "width_desc", label: "W: Large to Small" },

          { key: "thickness_asc", label: "Thickness: Low - High" },
        //  { key: "thickness_desc", label: "T: High to Low" },

          { key: "texture_asc", label: "Texture: Smooth - Rough" },
        //  { key: "texture_desc", label: "Rough to Smooth" },

          { key: "firmness_asc", label: "Firmness: Soft - Firm" },
        //  { key: "firmness_desc", label: "Firm to Soft" }

        ],

        // Map sort keys -> definition + direction
        custom: {
          area_asc:      { def: "area_mm2", dir: "asc" },
        //  area_desc:     { def: "area_mm2", dir: "desc" },

          thickness_asc: { def: "thickness_mm", dir: "asc" },
       //   thickness_desc:{ def: "thickness_mm", dir: "desc" },

          texture_asc:   { def: "texture_rank", dir: "asc" },
       //   texture_desc:  { def: "texture_rank", dir: "desc" },

          firmness_asc:  { def: "firmness_rank", dir: "asc" },
       //   firmness_desc: { def: "firmness_rank", dir: "desc" },

       //   width_asc:     { def: "width_mm", dir: "asc" },
       //   width_desc:    { def: "width_mm", dir: "desc" },

       //   length_asc:    { def: "length_mm", dir: "asc" },
       //   length_desc:   { def: "length_mm", dir: "desc" }
        }
      },
      "mice-skates": {
        options: [
          { key: "thickness_asc", label: "Thickness: Low - High" },
        ],
        custom: {
          thickness_asc: { def: "thickness_mm", dir: "asc" },
        }
      },
      "grip-tape": {
        options: [
          { key: "thickness_asc", label: "Thickness: Low - High" },
        ],
        custom: {
          thickness_asc: { def: "thickness_mm", dir: "asc" },
        }
        },
        "arm-sleeves": {
        options: [
          { key: "sleeve_asc", label: "Length: Low - High" },
        ],
        custom: {
          sleeve_asc: { def: "sleeve_cm", dir: "asc" },
        }
      },
        "keycaps": {
        options: [
          { key: "total_keys_asc", label: "Keys: Low - High" },
        ],
        custom: {
          total_keys_asc: { def: "total_keys", dir: "asc" },
        }
      },
       "wrist-rests": {
        options: [
          { key: "length_asc", label: "Length: Low - High" },
          { key: "width_asc", label: "Width: Low - High" },
          { key: "height_asc", label: "Height: Low - High" },
        ],
        custom: {
          length_asc:      { def: "length_mm", dir: "asc" },
          width_asc:       { def: "width_mm", dir: "asc" },
          height_asc:      { def: "height_mm", dir: "asc" },
        }
      },
    }
  };
})();
